export const address = {
  addressForm: {
    userAddressAddSuccess: 'La nouvelle adresse a été ajoutée avec succès !',
    userAddressUpdateSuccess: 'Vous avez modifié une adresse avec succès.',
    userAddressDeleteSuccess: "Une adresse vient d'être supprimée.",
  },
};
